// Canonical hub category list — must stay in sync with Tailoros
// and wavelines-shop/src/utils/constants.js.
export const HUB_CATEGORIES = [
  { value: "Tailoring",      label: "Tailoring"      },
  { value: "Fashion",        label: "Fashion"         },
  { value: "Shoes",          label: "Shoes"           },
  { value: "Accessories",    label: "Accessories"     },
  { value: "Electronics",    label: "Electronics"     },
  { value: "Food & Grocery", label: "Food & Grocery"  },
  { value: "Beauty",         label: "Beauty"          },
  { value: "Furniture",      label: "Furniture"       },
  { value: "Health",         label: "Health"          },
  { value: "Baby & Kids",    label: "Baby & Kids"     },
  { value: "Sports",         label: "Sports"          },
  { value: "Home & Living",  label: "Home & Living"   },
  { value: "Jewellery",      label: "Jewellery"       },
  { value: "Books",          label: "Books"           },
  { value: "Agriculture",    label: "Agriculture"     },
  { value: "Services",       label: "Services"        },
  { value: "Other",          label: "Other"           },
]